import React, { PropsWithChildren } from "react";
import { ScrollView, StyleSheet, View } from "react-native";

import { StatusBar } from "expo-status-bar";
import ReactNativeModal from "react-native-modal";

import { Button, Text } from "components";
import SelectedFiltersView from "screens/components/SelectedFiltersView";

import { colors, sizes, strings } from "assets/constants";
import { mq } from "utils";
import css from "styles";

import { useRecoilValue } from "recoil";
import { authAtom } from "stores";

interface FiltersTemplateProps {
  visible?: boolean;
  innerFilters?: any;
  setInnerFilters?: (filters: any) => void;
  filtersItems?: Array<{ key: string; title: string; value: any }>;
  _onApply?: () => void;
  _onCancel?: () => void;
}

export default function FiltersTemplate(
  props: PropsWithChildren<FiltersTemplateProps>
) {
  const {
    visible,
    innerFilters,
    setInnerFilters,
    filtersItems,
    _onApply,
    _onCancel,
  } = props;

  const {
    company: { color },
  } = useRecoilValue(authAtom);

  return (
    <ReactNativeModal
      animationIn={"slideInRight"}
      animationOut={"slideOutRight"}
      isVisible={visible}
      backdropColor={colors.bg.screen}
      backdropOpacity={1}
      style={{ margin: 0, backgroundColor: colors.bg.screen }}
    >
      <StatusBar backgroundColor={colors.bg.vLight} style="dark" />
      <View
        style={{
          backgroundColor: colors.bg.vLight,
          width: "100%",
          ...css.rRowCenterAlign,
          minHeight: mq(60),
          ...css.shadow(1),
        }}
      >
        <View style={{ paddingHorizontal: sizes.space }}>
          <Text weight="bold" size={"xxl"}>
            {strings.filters}
          </Text>
        </View>

        <View
          style={{
            height: mq(25),
            ...css.container,
          }}
        >
          <SelectedFiltersView
            filters={innerFilters}
            onChange={setInnerFilters}
            filterItems={filtersItems}
          />
        </View>

        <Button
          onPress={_onCancel}
          square={mq(45)}
          bgColor={colors.transparent}
          icon={{ name: "x", color: colors.text.normal, size: 23 }}
        />
      </View>
      <ScrollView
        contentContainerStyle={styles.content}
        showsVerticalScrollIndicator={false}
      >
        {props.children}
      </ScrollView>

      <View style={styles.footer}>
        <Button
          onPress={_onApply}
          width={mq(120)}
          title={{ value: strings.apply_filters, color: colors.white }}
          style={{ marginRight: sizes.space }}
        />

        <Button
          onPress={_onCancel}
          width={mq(100)}
          title={{ value: strings.cancel, color }}
          bgColor={colors.white}
          bordered={{ width: 1, color }}
        />
      </View>
    </ReactNativeModal>
  );
}

const styles = StyleSheet.create({
  container: { flex: 1 },

  content: {
    ...css.paddingH,
    paddingVertical: sizes.space,
    flexWrap: "wrap",
    flexDirection: "row-reverse",
    justifyContent: "space-between",
    maxWidth: sizes.deviceWidth.lg,
    width: "100%",
    alignSelf: "center",
  },

  footer: {
    bottom: mq(0),
    maxWidth: sizes.deviceWidth.lg,
    alignSelf: "center",
    width: "100%",
    padding: sizes.space,
    ...css.rowCenterAlign,
    position: "absolute",
    backgroundColor: colors.transparent,
  },
});
